import classNames from "classnames";
import React from "react";

import styles from "./Button.module.scss";

interface ButtonProps {
  id: string;
  value?: string;
  label?: string;
  onClick?: () => void;
  textStyle?: React.CSSProperties;
  readonly?: boolean;
  functionType?: "copyRow" | "addRow" | "moveRow" | "deleteRow" | string;
}

export function Button({
  id,
  value,
  label,
  onClick,
  textStyle,
  readonly,
  functionType,
}: ButtonProps) {
  const content = label ?? (value !== undefined ? String(value) : "Button");

  return (
    <button
      id={id}
      className={classNames(
        styles.button,
        functionType && (styles as any)[functionType],
      )}
      style={textStyle}
      onClick={readonly ? undefined : onClick}
      disabled={readonly}
      type="button">
      {content}
    </button>
  );
}
